import { Component, TemplateRef, ViewChild, OnInit, EventEmitter, Output } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { Tva, TvaService } from '../tva.service';

@Component({
  selector: 'app-croud-tva',
  templateUrl: './croud-tva.component.html',
  styleUrls: ['./croud-tva.component.scss']
})
export class CroudTvaComponent implements OnInit {

  @ViewChild('modalLG') modalTemplate!: TemplateRef<any>;
  @Output() tvaAdded = new EventEmitter<void>();
  @Output() tvaUpdated = new EventEmitter<Tva>();
  private modalRef: NgbModalRef | null = null;
  modalType: 'ajouter' | 'update' | 'etat' = 'ajouter';
  isLoading: boolean = false;
  tvaData: Tva = {
    id: 0,
    client_id: 1,
    station_id: 1,
    valeur: 1,
    type: '+',
    restriction: 'Pourcentage',
    statut: true
  };
  newStatut: boolean | null = null;
  confirmationMessage: string | null = null;
  stationId: number | null = null;
  clientId: number | null = null;

  constructor(
    private modalService: NgbModal,
    private toastr: ToastrService,
    private tvaService: TvaService
  ) {}

  ngOnInit(): void {
    this.loadUserData();
  }

  loadUserData(): void {
    const user = localStorage.getItem('currentUser');
   // console.log('CroudTvaComponent: Current user from localStorage:', user);
    if (user) {
      try {
        const currentUser = JSON.parse(user);
        if (currentUser?.stations?.length > 0) {
          this.stationId = currentUser.stations[0].id;
          this.clientId = currentUser.id;
          this.tvaData.station_id = this.stationId;
          this.tvaData.client_id = this.clientId;
        //  console.log('CroudTvaComponent: Station ID set:', this.stationId, 'Client ID:', this.clientId);
        } else {
          this.toastr.error('Aucune station trouvée. Veuillez créer une station.', 'Erreur');
         // console.error('CroudTvaComponent: No stations found in currentUser');
        }
      } catch (error) {
        this.toastr.error('Erreur lors de la lecture des données utilisateur.', 'Erreur');
        //console.error('CroudTvaComponent: Error parsing currentUser:', error);
      }
    } else {
      this.toastr.error('Utilisateur non connecté.', 'Erreur');
    //  console.error('CroudTvaComponent: No currentUser in localStorage');
    }
  }

  openModal(type: 'ajouter' | 'update' | 'etat' = 'ajouter', tva?: Tva, statut?: boolean): void {

 // console.log("je suis ciiccicici")
    this.modalType = type;
    this.resetForm();

    if (type === 'update' || type === 'etat') {
      if (tva) {
        this.tvaData = {
          ...tva,
          client_id: this.clientId || 1,
          station_id: this.stationId || 1,
          restriction: 'Pourcentage'
        };
        if (type === 'etat') {
          this.newStatut = statut !== undefined ? statut : !this.tvaData.statut;
          this.confirmationMessage = `Êtes-vous sûr de vouloir ${this.newStatut ? 'activer' : 'désactiver'} la TVA ${this.tvaData.valeur}${this.tvaData.restriction === 'Pourcentage' ? '%' : ' TND'} ?`;
        }
      }
    }

    const options: NgbModalOptions = {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false
    };
    try {
      this.modalRef = this.modalService.open(this.modalTemplate, options);
     // console.log('CroudTvaComponent: Modal opened successfully');
    } catch (error) {
      console.error('CroudTvaComponent: Error opening modal:', error);
      this.toastr.error('Erreur lors de l\'ouverture du modal', 'Erreur');
    }
  }

  resetForm(): void {
    this.tvaData = {
      id: 0,
      client_id: this.clientId || 1,
      station_id: this.stationId || 1,
      valeur: 1,
      type: '+',
      restriction: 'Pourcentage',
      statut: true
    };
    this.newStatut = null;
    this.confirmationMessage = null;
  }

  cancelModal(): void {
    //this.toastr.info('Action annulée', 'Information');
    this.isLoading = false;
    if (this.modalRef) {
      this.modalRef.dismiss('Cancel click');
      this.modalRef = null;
     // console.log('CroudTvaComponent: Modal dismissed');
    }
  }

  onSubmit(form: NgForm): void {
    if (this.stationId === null) {
      this.toastr.error('Aucune station disponible.', 'Erreur');
   //   console.error('CroudTvaComponent: No stationId available');
      this.isLoading = false;
      return;
    }

    if (!this.modalRef) {
    //  console.error('CroudTvaComponent: modalRef is null, cannot close modal');
      this.toastr.error('Erreur: modal non initialisé.', 'Erreur');
      this.isLoading = false;
      return;
    }

    if (this.modalType === 'etat' && this.tvaData.id !== 0) {
      this.isLoading = true;
      const tva = { ...this.tvaData, statut: this.newStatut !== null ? this.newStatut : this.tvaData.statut };
     // console.log('CroudTvaComponent: Updating TVA status:', tva);
      this.tvaService.updateTva(tva, this.stationId).subscribe({
        next: (response) => {
        //  console.log('CroudTvaComponent: Update TVA response:', response);
          if (response?.success) {
            this.toastr.success(`TVA ${tva.statut ? 'activée' : 'désactivée'} avec succès`, 'Succès');
            this.tvaUpdated.emit(tva);
            this.modalRef!.close('Accept click');
            this.modalRef = null;
            this.isLoading = false;
          } else {
            this.toastr.error('Échec de la mise à jour de la TVA.', 'Erreur');
          //  console.error('CroudTvaComponent: Update TVA response unsuccessful:', response);
            this.isLoading = false;
          }
        },
        error: (error) => {
          this.toastr.error('Erreur lors du changement de statut: ' + (error.message || 'Erreur inconnue'), 'Erreur');
          //console.error('CroudTvaComponent: Update status error:', error);
          this.isLoading = false;
        }
      });
    } else if (form.valid) {
      this.isLoading = true;
      const tva = { ...this.tvaData };
    //  console.log('CroudTvaComponent: Submitting TVA:', tva);
      if (this.modalType === 'ajouter') {


        this.tvaService.createTva(tva, this.stationId).subscribe({
          next: (response) => {
           // console.log('CroudTvaComponent: Create TVA response:', response);
            if (response?.success) {
                console.log(response)
              this.toastr.success('TVA ajoutée avec succès', 'Succès');
              this.tvaAdded.emit();
              this.modalRef!.close('Accept click');
              this.modalRef = null;
              this.isLoading = false;
                this.tvaService.sendMessage(response);
            } else {
              this.toastr.error('Échec de l\'ajout de la TVA.', 'Erreur');
           //   console.error('CroudTvaComponent: Create TVA response unsuccessful:', response);
              this.isLoading = false;
            }
          },
          error: (error) => {
            this.toastr.error('Erreur lors de l\'ajout: ' + (error.message || 'Erreur inconnue'), 'Erreur');
            //console.error('CroudTvaComponent: Create error:', error);
            this.isLoading = false;
          }
        });
      } else if (this.modalType === 'update' && this.tvaData.id !== 0) {
        this.tvaService.updateTva(tva, this.stationId).subscribe({
          next: (response) => {
           // console.log('CroudTvaComponent: Update TVA response:', response);
            if (response?.success) {
              this.toastr.success('TVA mise à jour avec succès', 'Succès');
              this.tvaUpdated.emit(tva);
              this.modalRef!.close('Accept click');
              this.modalRef = null;
              this.isLoading = false;
            } else {
              this.toastr.error('Échec de la mise à jour de la TVA.', 'Erreur');
            //  console.error('CroudTvaComponent: Update TVA response unsuccessful:', response);
              this.isLoading = false;
            }
          },
          error: (error) => {
            this.toastr.error('Erreur lors de la mise à jour: ' + (error.message || 'Erreur inconnue'), 'Erreur');
           // console.error('CroudTvaComponent: Update error:', error);
            this.isLoading = false;
          }
        });
      }
    } else {
      this.toastr.error('Veuillez remplir tous les champs requis.', 'Erreur');
     // console.warn('CroudTvaComponent: Form is invalid:', form);
      this.isLoading = false;
    }
  }

  incrementValue(): void {
    this.tvaData.valeur = (this.tvaData.valeur || 1) + 1;
  }

  decrementValue(): void {
    if (this.tvaData.valeur > 0) {
      this.tvaData.valeur -= 1;
    }
  }

}